import { ComponentProps } from 'react'
import { hotkeyKeys } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'

type HotkeyHintProps = ComponentProps<'span'> & {
  hotkey: string
  keyClassName?: string
}

export const HotkeyHint = ({ hotkey, onClick, className, keyClassName, ...props }: HotkeyHintProps) => {
  return (
    <span
      className={twMerge(
        'text-foreground-placeholder bg-foreground/[2%] mx-[1px] inline-flex w-fit items-center rounded-[7px]',
        'shadow-md',
        'transition-[color,box-shadow]',
        typeof onClick === 'function' && 'hover:shadow-yellow/5 cursor-pointer hover:shadow-lg',
        className,
      )}
      onClick={onClick}
      {...props}
    >
      {hotkeyKeys(hotkey).map((key, index) => {
        return (
          <span
            key={key}
            className={twMerge(
              'min-w-5 px-1.5 py-0.5 text-center text-[12px] font-semibold capitalize',
              index > 0 ? 'border-l' : '',
              keyClassName,
            )}
          >
            {key}
          </span>
        )
      })}
    </span>
  )
}
